(function () {
  function getLanguageCode() {
    const lang = document.documentElement.getAttribute("lang") || "en";
    return lang.toLowerCase().split("-")[0];
  }

  function translateGuestAccessCard() {
    const translations = {
      de: {
        kicker: "GROSSHANDELSZUGANG",
        title: "DIESER BEREICH IST FÜR FREIGESCHALTETE GROSSHANDELSPARTNER",
        subtitle:
          "Bitte melden Sie sich an, um fortzufahren. Falls Sie noch keinen Zugang haben, beantragen Sie ihn.",
        login: "Anmelden",
        request: "Zugang beantragen"
      },
      fr: {
        kicker: "ACCÈS GROSSISTE",
        title:
          "CETTE SECTION EST RÉSERVÉE AUX PARTENAIRES GROSSISTES AGRÉÉS",
        subtitle:
          "Connectez-vous pour continuer. Si vous n’avez pas encore accès, faites-en la demande.",
        login: "Se connecter",
        request: "Demander l’accès"
      },
      it: {
        kicker: "ACCESSO ALL’INGROSSO",
        title:
          "QUESTA SEZIONE È RISERVATA AI PARTNER ALL’INGROSSO AUTORIZZATI",
        subtitle:
          "Accedi per continuare. Se non hai ancora accesso, richiedilo.",
        login: "Accedi",
        request: "Richiedi accesso"
      },
      es: {
        kicker: "ACCESO MAYORISTA",
        title:
          "ESTA SECCIÓN ESTÁ RESERVADA A SOCIOS MAYORISTAS AUTORIZADOS",
        subtitle:
          "Inicia sesión para continuar. Si aún no tienes acceso, solicítalo.",
        login: "Iniciar sesión",
        request: "Solicitar acceso"
      },
      cs: {
        kicker: "VELKOOBCHODNÍ PŘÍSTUP",
        title:
          "TATO SEKCE JE URČENA SCHVÁLENÝM VELKOOBCHODNÍM PARTNERŮM",
        subtitle:
          "Pro pokračování se přihlaste. Pokud ještě nemáte přístup, požádejte o něj.",
        login: "Přihlásit se",
        request: "Požádat o přístup"
      },
      tr: {
        kicker: "Toptan satış erişimi",
        title: "BU BÖLÜM ONAYLI TOPTAN SATIŞ İŞ ORTAKLARI İÇİNDİR",
        subtitle: "Devam etmek için lütfen giriş yapın. Henüz erişiminiz yoksa erişim talebinde bulunun.",
        login: "Giriş yapın",
        request: "Erişim talep edin"
      },
      ar: {
        kicker: "الدخول لقسم الجملة",
        title: "هاد القسم غير للشركاء المعتمدين ديال البيع بالجملة",
        subtitle: "عافاك دخل لحسابك باش تكمّل. إلا مازال ما عندكش الولوج، قدّم طلب.",
        login: "دخل لحسابك",
        request: "طلب الولوج"
      }
    };

    const language = getLanguageCode();
    const copy = translations[language === "ary" ? "ar" : language];
    if (!copy) return;

    const guestCard = Array.from(
      document.querySelectorAll(".gtr-bulk__hero")
    ).find((card) => {
      const kicker = card.querySelector(".gtr-bulk__kicker");

      return (
        kicker &&
        kicker.textContent.trim().toLowerCase() === "wholesale access"
      );
    });

    if (!guestCard) return;

    if (language === "ar" || language === "ary" || language === "tr") {
      const guestRoot = guestCard.closest(".gtr-bulk") || guestCard;
      const isDarija = language === "ar" || language === "ary";

      guestRoot.setAttribute("lang", isDarija ? "ary" : "tr");
      guestRoot.setAttribute("dir", isDarija ? "rtl" : "ltr");
    }

    const kicker = guestCard.querySelector(".gtr-bulk__kicker");
    const title = guestCard.querySelector(".gtr-bulk__title");
    const subtitle = guestCard.querySelector(".gtr-bulk__subtitle");
    const buttons = guestCard.querySelectorAll(
      ".gtr-bulk__ctaRow .gtr-pill"
    );

    if (kicker) kicker.textContent = copy.kicker;
    if (title) title.textContent = copy.title;
    if (subtitle) subtitle.textContent = copy.subtitle;
    if (buttons[0]) buttons[0].textContent = copy.login;
    if (buttons[1]) buttons[1].textContent = copy.request;
  }

  function money(val, currency) {
    if (val === null || val === undefined) return "—";
    if (typeof val === "string") return val;

    const n = Number(val);
    if (Number.isNaN(n)) return "—";

    const cur = (currency || "EUR").toUpperCase();
    const fractionDigits = n < 0.2 ? 3 : 2;

    try {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: cur,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      }).format(n);
    } catch (e) {
      // Fallback if currency code is invalid for some reason
      const symbol = cur === "EUR" ? "€" : cur === "EURO" ? "€" : "";

      const s =
        n < 0.2
          ? n.toFixed(3).replace(/0+$/, "").replace(/\.$/, "")
          : n.toFixed(2).replace(/0+$/, "").replace(/\.$/, "");

      return symbol ? `${s} ${symbol}` : s;
    }
  }

  function formatTierLabel(t) {
    // de-DE formatting: 10.000+
    return `${Number(t).toLocaleString("de-DE")}+`;
  }

  function formatTierHeader(t) {
    // "10.000 seeds" -> you can localize later if you want
    return `${Number(t).toLocaleString("de-DE")} seeds`;
  }

  function setTier(root, tier) {
    root.dataset.tier = String(tier);

    const buttons = root.querySelectorAll("[data-tier-btn]");

    buttons.forEach((btn) =>
      btn.setAttribute(
        "aria-selected",
        btn.dataset.tierBtn === String(tier) ? "true" : "false"
      )
    );

    root.querySelectorAll(".gtr-highlight").forEach((el) =>
      el.classList.remove("gtr-highlight")
    );

    root
      .querySelectorAll(`[data-tier="${tier}"].gtr-col`)
      .forEach((el) => el.classList.add("gtr-highlight"));
  }

  function render(root, data) {
    const seg = root.querySelector("[data-seg]");
    const thead = root.querySelector("thead");
    const tbody = root.querySelector("tbody");
    const search = root.querySelector("[data-search]");

    if (!seg || !thead || !tbody) return;

    const tiers = Array.isArray(data.tiers) ? data.tiers : [];
    const strains = Array.isArray(data.strains) ? data.strains : [];
    const currency = data.currency || "EUR";

    seg.innerHTML = "";

    tiers.forEach((t) => {
      const b = document.createElement("button");

      b.type = "button";
      b.dataset.tierBtn = String(t);
      b.setAttribute("role", "tab");
      b.setAttribute("aria-selected", "false");
      b.textContent = formatTierLabel(t);
      b.addEventListener("click", () => setTier(root, t));

      seg.appendChild(b);
    });

    const trh = document.createElement("tr");

    const th0 = document.createElement("th");
    th0.textContent = "Strain";
    th0.style.textAlign = "left";
    trh.appendChild(th0);

    tiers.forEach((t) => {
      const th = document.createElement("th");

      th.dataset.tier = String(t);
      th.className = "gtr-col";
      th.textContent = formatTierHeader(t);

      trh.appendChild(th);
    });

    thead.innerHTML = "";
    thead.appendChild(trh);

    function rowMatches(strain, q) {
      if (!q) return true;

      const s = `${strain.name || ""} ${(
        strain.tags || []
      ).join(" ")}`.toLowerCase();

      return s.includes(q);
    }

    function drawRows(q) {
      tbody.innerHTML = "";

      strains
        .filter((st) => rowMatches(st, q))
        .forEach((st) => {
          const tr = document.createElement("tr");

          const tdName = document.createElement("td");
          tdName.style.textAlign = "left";

          const safeName = st.name || "";
          const safeSubtitle = st.subtitle || "";
          const tags = Array.isArray(st.tags) ? st.tags : [];

          tdName.innerHTML = `
            <div class="gtr-name">
              <strong>${safeName}</strong>
              ${
                safeSubtitle
                  ? `<span>${safeSubtitle}</span>`
                  : `<span>&nbsp;</span>`
              }
              ${
                tags.length
                  ? `<div class="gtr-badgeRow">${tags
                      .map(
                        (t) =>
                          `<span class="gtr-badge">${t}</span>`
                      )
                      .join("")}</div>`
                  : ``
              }
            </div>
          `;

          tr.appendChild(tdName);

          tiers.forEach((t) => {
            const td = document.createElement("td");

            td.dataset.tier = String(t);
            td.className = "gtr-col";

            const priceMap = st.prices || {};
            const raw = priceMap[String(t)];

            // If raw is numeric: convert from USD base -> EUR * multiplier
            let out = raw;

            if (typeof raw === "number") {
              const fx = Number(data.fx || 1);
              const mult = Number(data.multiplier || 1);

              out = raw * fx * mult;
            }

            td.textContent = money(out, currency);

            tr.appendChild(td);
          });

          tbody.appendChild(tr);
        });

      setTier(
        root,
        root.dataset.tier || String(tiers[0] || "")
      );
    }

    drawRows("");

    if (search) {
      search.addEventListener("input", (e) => {
        const q = String(e.target.value || "")
          .trim()
          .toLowerCase();

        drawRows(q);
      });
    }

    const defaultTier =
      root.dataset.defaultTier || String(tiers[0] || "");

    if (defaultTier) setTier(root, defaultTier);
  }

  document.addEventListener("DOMContentLoaded", () => {
    translateGuestAccessCard();

    document
      .querySelectorAll("[data-gtr-bulk]")
      .forEach((root) => {
        const jsonEl = root.querySelector(
          "script[type='application/json']"
        );

        if (!jsonEl) return;

        let data;

        try {
          data = JSON.parse(jsonEl.textContent);
        } catch (e) {
          return;
        }

        render(root, data);
      });
  });
})();